module.exports = __webpack_public_path__ + "static/media/healthy-white.a3e58705.svg";